import { Setting } from '../../../../types/Setting'

export const settingKeys = ['game_analyst_map', 'serviceVersionInfo', 'performance', 'featured_games'] as const
export type SettingKey = (typeof settingKeys)[number]
export const settingServices = ['apiserver'] as const
export type SettingService = (typeof settingServices)[number]

export type ServiceVersionInfoData = { versionNumber?: string }

export const performanceConditionTypes = ['gps', 'rank'] as const
export type PerformanceConditionType = (typeof performanceConditionTypes)[number]
export const performanceOperators = ['>', '>=', '<', '<=', '=='] as const
export type PerformanceOperator = (typeof performanceOperators)[number]
export const performanceRuleKinds = ['overperforming', 'underperforming'] as const
export type PerformanceRuleKind = (typeof performanceRuleKinds)[number]

// `value` is a string while being edited; stored values are numbers.
export type PerformanceCondition = { type: PerformanceConditionType; operator: PerformanceOperator; value: number | string }
// OR groups of AND conditions.
export type PerformanceConditionGroups = PerformanceCondition[][]
export type PerformanceRules = Partial<Record<PerformanceRuleKind, PerformanceConditionGroups>>
export type PerformanceSettingData = { [marketIso: string]: PerformanceRules }

// `compareOrder` is `'<id>,<id>&<iso>,<iso>'`, or `''` when nothing is compared.
export type FeaturedGamesSettingData = { featuredGames?: string[]; compareOrder?: string }
export type ComparedGame = { gameId: string; marketIso: string }

export type FeaturedGamesSetting = Omit<Setting<FeaturedGamesSettingData>, 'id' | 'createdAt' | 'modifiedAt' | 'createdBy' | 'modifiedBy'> &
  Partial<Pick<Setting, 'id' | 'createdAt' | 'modifiedAt' | 'createdBy' | 'modifiedBy'>>
